// extracted by mini-css-extract-plugin
export default {"code_block":"markdown_code_block__Xx+Xt","table":"markdown_table__yQxTM","th":"markdown_th__Ru1sm","td":"markdown_td__EPP0O","tr":"markdown_tr__5Q8pm","a":"markdown_a__sqIq3"};